<template>
  <div class="offer-page">
    <o-section class="nav-visible hash-link top" ref="hero">
      <b-container>
        <b-row>
          <b-col cols="12">
            <div
              class="navigation-back my-5"
              @click="$router.push({ name: Routes.CAREERS, hash: RouteSections.JOIN_US })"
            >
              <p class="h5 mb-0"><a-tec-icon icon="arrow-left" /> Back to Job Opportunities</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <t-offer-description :position="position" />
          </b-col>
          <b-col cols="12" lg="5" offset-lg="1" class="offer-application-col">
            <div class="offer-application-sticky">
              <t-offer-apply class="px-0" :message="`${position.title} / ${position.cities}`" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </o-section>
    <o-section class="align-items-center">
      <t-careers-benefits />
    </o-section>
    <o-section class="align-items-center">
      <t-careers-process />
    </o-section>
    <o-section class="align-items-center mb-5">
      <t-careers-cv />
    </o-section>
  </div>
</template>
<script>
import POSITIONS from "@/components/_templates/careers-join-us/enum";
import ATecIcon from "@/components/_atoms/tec-icon/a-tec-icon.vue";
import OSection from "@/components/_organisms/section/o-section";
import TCareersBenefits from "@/components/_templates/careers-benefits/t-careers-benefits";
import TCareersCv from "@/components/_templates/careers-cv/t-careers-cv.vue";
import TCareersProcess from "@/components/_templates/careers-process/t-careers-process.vue";
import TOfferApply from "@/components/_templates/offer-apply/t-offer-apply";
import TOfferDescription from "@/components/_templates/offer-description/t-offer-description";
import { Routes, RouteSections } from "@/helpers/routes";

export default {
  name: "VOffer",
  components: {
    ATecIcon,
    OSection,
    TCareersBenefits,
    TCareersCv,
    TCareersProcess,
    TOfferApply,
    TOfferDescription,
  },
  data() {
    return {
      Routes,
      RouteSections,
    };
  },
  props: {
    positionId: {
      type: [String, Number],
    },
  },
  computed: {
    position() {
      return POSITIONS.find((el) => el.id == this.positionId);
    },
  },
};
</script>
